import { fundamentalsLogoSrc } from '@/views/FundamentalsView/fundamentalsLogo';
import { asset } from '@/utils/basePath';

/**
 * Logo "Fundamentales" en composición APILADA (2 renglones: "FUNDA" / "MENTALES"), para los slots
 * angostos donde el wordmark ancho (`fundamentalsLogoSrc`, `viewBox` 1738×439) no cabe — mismo molde
 * que `shineLogo.ts`.
 *
 * QA (2026-09-01) — DT-029: el asset que ocupaba este slot (`/fundamentals-v2.svg`) tenía la palabra
 * "FUNDAMENTALS" en INGLÉS dibujada letra por letra, sin variante por idioma — igual que el bug
 * original de Brillamos, pero nunca se había fotografiado como tal porque nadie había vinculado
 * "el logo apilado de Fundamentales" con "el logo de Shine Together" como el mismo patrón.
 *
 * El cliente entregó el reemplazo en esta composición apilada SOLO en español
 * (`fundamentales_dosfilas.svg` → `logo-fundamentales-dosfilas-es.svg`). Decisión de producto
 * (2026-09-01): para español se usa ese arte nuevo; para los otros 6 idiomas, sin arte propio en
 * esta composición, se cae al wordmark ANCHO (`fundamentalsLogoSrc`) — cambia de idioma
 * correctamente, aunque la proporción visual difiere entre español y el resto hasta que el cliente
 * entregue el apilado en los demás idiomas.
 */
// `asset()` por el prefijo de ambiente: en dev el portal vive bajo `/dev` y sin él este SVG se
// pediria a la raiz, es decir a QA. `fundamentalsLogoSrc` ya lo hace; este slot se escapo del
// barrido del 2026-09-05 porque el fichero es anterior (DT-029, 2026-09-01).
const STACKED_LOGO_ES = asset('/assets/logo-fundamentales-dosfilas-es.svg');

export function fundamentalsStackedLogoSrc(lang: string): string {
  const shortCode = lang.split('-')[0].toLowerCase();
  return shortCode === 'es' ? STACKED_LOGO_ES : fundamentalsLogoSrc(lang);
}
